import React, { FC, useState } from "react";
import { RouterParamType } from "@/model/navModel";
import { TableBox } from "./TableBox";
import { MaterialDiolog } from "./MaterialDialog";


export const MaterialInfo: FC<RouterParamType> = (detailsInfo) => {

    return (
        <>
            <TableBox {...detailsInfo} />
            <MaterialDiolog {...detailsInfo} />
        </>
    )
}